<template>

    <div class='white-panel-items'>
        <div class='wp-row'>
            <div class='info-panel-text info-panel-text-uppercase'>
                <b v-if="$i18n.locale == 'kk'">
                    {{ docDate }} {{ docNumber }} {{ documentName }}{{ docVersion }}
                </b>
                <b v-else>
                    {{ documentName }} {{ docNumber }} {{ docDate }}{{ docVersion }}
                </b>
            </div>

            <v-common-chip 
                v-if="isCommon && (dsType === 'IncomingDocument' || dsType === 'OutgoingDocument' || dsType === 'NPADocument' || dsType === 'ReportQuery' || dsType === 'InnerDocument')"
                :document-type="dsType"
            />

            <v-btn
                v-if="showFavoriteBtn"
                x-small
                icon
                color="orange"
                @click="handleFavoriteClick"
                v-tooltip.top="$t(this.favoriteValue ? 'Удалить_из_избранного' : 'Добавить_в_избранное')"
            >
              <v-icon>{{ this.favoriteValue ? 'fas' : 'far' }} fa-star</v-icon>
            </v-btn>

            <div class='info-panel-text info-panel-status-text'>{{ documentStatusText }}</div>
        </div>

        <!--Action Panels-->
        <div class='wp-row' v-for="actionpanel in ActionPanels"
            :key="actionpanel.Code" 
        >
            <div class='info-panel-text d-flex align-center'>
                <span> {{ actionpanel.Text }} </span>
                <v-employee-chip v-if="actionpanel.Name === 'Prolongate'" :id="prolongationRequest.SenderEmployeeId" :name="prolongationRequest.SenderName" />
            </div>
            <v-spacer></v-spacer>

            <div class="doc-actions-wrap">
                <template v-for="(item, index) in actionpanel.Buttons">
                    <v-btn
                        :key="item.Action + index"
                        @click="actionButtonClick($event, item)"
                        v-tooltip.bottom="$t(item.ToolTip)"
                        class="middle-green-button m-g-b-middle"
                        :color="item.Default ? 'teal' : 'black'"
                        small 
                        dark
                        depressed
                        :outlined="!item.Default"
                    >
                        <i :class="mapIcon(item.Icon)"></i>
                        <template>{{ $t(item.Text) }}</template>
                    </v-btn>
                </template>
            </div>
        </div>

    </div>

</template>

<script>
import sys from '@/services/system'
import { mapGetters } from 'vuex';

export default
{
    name: 'DocumentPanel',
    props:
    {
        documentInfo: {
            type: Object,
            default: null
        },
        showFavoriteBtn: {
            type: Boolean,
            default: false
        },
        favoriteValue: {
            type: Boolean,
            default: false
        },
        favoriteClickHandler: {
            type: Function,
            default: null
        }
    },
    data()
    {
        return {
          
        }
    },
    computed:
    {
        ...mapGetters('documents/toolbar', [ 'getActionButtons', 'getIcons']),
        ...mapGetters('global/actionsource', { dataSource: 'getDataSource' }),
        document() {
            return this.dataSource?.Data?.Object?.Document;
        },
        ActionPanels() {
            let panels = [];
            if (this.document){
                const buttons = this.getActionButtons;
                if (this.document.__type == "ProtocolDocument:#Avrora.Objects.Modules.Docflow.DocflowObjects" && this.document.Card?.TypeC4 == 3){
                    const orderTakeOffPanelButtons = buttons.filter(b => b.Action === "ReturnWithReason" || b.Action === "TakeOffControl" || b.Action === "BeginAdjustment");
                    if (orderTakeOffPanelButtons.length > 0){
                        panels.push({
                            Code: 1,
                            Name: 'OrderTakeOff',
                            Buttons: orderTakeOffPanelButtons,
                            Text: this.$t('Документ_исполнен_и_направлен_на_снятие_с_контроля')
                        });
                    }
                    const prolongatePanelButtons = buttons.filter(b => b.Action === "RejectProlongationRequest" || b.Action === "AcceptProlongationRequest");
                    if (prolongatePanelButtons.length > 0 && this.prolongationRequest){
                        panels.push({
                            Code: 2,
                            Name: 'Prolongate',
                            Buttons: prolongatePanelButtons,
                            Text: this.$t('Получено_уведомление_о_продлении_контрольного_срока_до_toDate_от.message', { toDate: this.$moment(this.prolongationRequest.RequestedControlDate).format('DD.MM.YYYY') })
                        });
                    }
                }
                const setAdjustmentBtn = buttons.find(b => b.Action === "SetAdjustment");
                if (setAdjustmentBtn){
                    let panelText = 'Документ_направлен_на_согласование';
                    let adjustmetPanelButtons = [];
                    let acceptBtn = {
                        Action: "SetAdjustmentAccept",
                        Icon: setAdjustmentBtn.Icon,
                        Text: "Согласовать",
                        ToolTip: "Согласовать_документ",
                        Type: setAdjustmentBtn.Type,
                        Default: true,
                        Localize: true
                    };
                    let  returnBtn = {
                        Action: "SetAdjustmentReturn",
                        Icon: "doc_return",
                        Text: "Вернуть_на_доработку", 
                        ToolTip: "Вернуть_документ_на_доработку",
                        Type: setAdjustmentBtn.Type,
                        Localize: true
                    };
                    let acceptECPBtn = {
                        Action: "SetAdjustmentWithSign",
                        Icon: setAdjustmentBtn.Icon,
                        Text: "Согласовать_с_ЭЦП",
                        ToolTip: "Согласовать_документ_с_ЭЦП",
                        Type: setAdjustmentBtn.Type,
                        Localize: true
                    };
                    let refuseBtn = {
                        Action: "SetAdjustmentRefuse",
                        Icon: "",
                        Text: "Отклонить",
                        ToolTip: "Отклонить_документ_без_согласование",
                        Type: setAdjustmentBtn.Type,
                        Localize: true
                    };
                    if (this.document.Card?.TypeC4 == 3 || this.documentInfo.__type == 'ActItem:#Avrora.Objects.Modules.Docflow.DocflowObjects'){
                        acceptBtn.Text = "Принять";
                        acceptBtn.ToolTip = "Принять_исполнение_документа";
                        refuseBtn.ToolTip = "Отклонить_исполнение_документа";
                        panelText = 'Документ_исполнен_и_направлен_на_проверку_исполнения';
                        adjustmetPanelButtons = [acceptBtn, returnBtn];
                    }
                    else 
                        adjustmetPanelButtons = [acceptBtn, acceptECPBtn, returnBtn];
                        
                    if (this.documentInfo.__type != 'ProtocolDocument:#Avrora.Objects.Modules.Docflow.DocflowObjects')
                        adjustmetPanelButtons.push(refuseBtn);
                    panels.push({
                        Code: 3,
                        Name: 'Adjustment',
                        Buttons: adjustmetPanelButtons,
                        Text: this.$t(panelText)
                    });
                }
                const signBtn = buttons.find(b => b.Action === "Sign");
                if (signBtn){
                    let signPanelButtons = [
                        {
                            Action: "SignAccept",
                            Icon: "sign_add",
                            Text: "Подписать",
                            ToolTip: "Подписать_документ",
                            Type: signBtn.Type,
                            Default: true,
                            Localize: true
                        },
                        {
                            Action: "SignReturn",
                            Icon: "doc_return",
                            Text: "Вернуть_на_доработку", 
                            ToolTip: "Вернуть_документ_на_доработку",
                            Type: signBtn.Type,
                            Localize: true
                        },
                        {
                            Action: "SignRefuse",
                            Icon: "",
                            Text: "Отклонить",
                            ToolTip: "Отказать_в_подписи_документа",
                            Type: signBtn.Type,
                            Localize: true
                        }
                    ];
                    panels.push({
                        Code: 4,
                        Name: 'Sign',
                        Buttons: signPanelButtons,
                        Text: this.$t('Документ_направлен_на_подпись')
                    });
                }
            }
            return panels;
        },  
        prolongationRequest() {
            return this.document?.CurrentProlongationRequest;
        },
        isCommon(){
            let common = this.documentInfo?.IsCommon;
            let type = this.documentInfo?.__type?.split(':')[0] ?? null;

            switch (type)
            {
                case 'DocumentContainer':
                    common = this.documentInfo?.Document?.IsCommon ?? null;
                    break;

                case 'ResolutionContainer':
                    common = this.documentInfo?.Resolution?.IsCommon ?? null;
                    break;

                default:
                    break;
            }

            return common;
        },
        dsType(){
            let type = this.documentInfo?.__type?.split(':')[0] ?? null;

            switch (type)
            {
                case 'DocumentContainer':
                    type = this.documentInfo?.Document?.__type?.split(':')[0] ?? null;
                    break;

                /*case 'ResolutionContainer':
                {
                    let hasType = has(this.documentInfo, 'Resolution.__type');
                    
                    hasType
                        ? type = this.documentInfo?.Resolution?.__type?.split(':')[0]
                        : type = 'Resolution';

                    break;
                }*/
                default:
                    break;
            }
            return type;
        },
        incommingDocumentNameByTypeC4() {
            switch(this.documentInfo.Document.Card.TypeC4)
            {
                default:
                case 0: return this.$t('Входящий_документ');
                case 2: return this.$t('Директивный_организационно_распорядительный_документ');
                case 3: return this.$t('Пункт_к_входящему_документу');
            }
        },
        innergDocumentNameByTypeC4() {
            switch (this.documentInfo.Document.Card.TypeC4)
            {
                default:
                case 0:
                {
                    let text = this.documentInfo.Document.RegState != 1 ? this.$t('Проект_внутреннего_документа') : this.$t('Внутренний_документ');

                    if (this.documentInfo.Document.Template?.Name)
                        text += ` (${this.documentInfo.Document.Template.Name})`

                    return text;
                }

                case 1:
                    return this.documentInfo.Document.RegState != 1
                        ? this.$t('Проект_организационно-распорядительного_документа')
                        : this.$t('Организационно-распорядительный_документ');
            }
        },
        protocolDocumentNameByTypeC4(){
            switch(this.documentInfo.Document.Card.TypeC4)
            {
                default:
                case 2: return this.$t('Протокол');
                case 3: return this.$t('Пункт_протокола');
            }
        },
        euolStatementNameByPerCategory() {
            switch(this.documentInfo.Document.Card.PerCategory)
            {
                case 1: return this.$t('Обращение_физического_лица');
                case 2: return this.$t('Обращение_юридического_лица');
                default: return this.$t('Обращение');
            }
        },
        iQalaStatementDocumentName() {
            return `${this.$t('Заявка')}`;
        },
        contractDocumentName() {
            return `${this.$t('Договор')}`;
        },
        documentName()
        {
            let type;
            switch (this.documentInfo.__type)
            {
                case 'DocumentContainer:#Avrora.Objects.Modules.Docflow.Web': type = this.documentInfo.Document.__type; break;
                case 'Resolution:#Avrora.Objects.Modules.Docflow.DocflowObjects': type = 'Resolution:#Avrora.Objects.Modules.Docflow.DocflowObjects'; break;
                case 'ReportResolution:#Avrora.Objects.Modules.Docflow.DocflowObjects': type = 'ReportResolution:#Avrora.Objects.Modules.Docflow.DocflowObjects'; break;
                case 'ActItem:#Avrora.Objects.Modules.Docflow.DocflowObjects': type = 'ActItem:#Avrora.Objects.Modules.Docflow.DocflowObjects'; break;
                case 'Order:#Avrora.Objects.Modules.Docflow.DocflowObjects': type = 'Order:#Avrora.Objects.Modules.Docflow.DocflowObjects'; break;
                case 'IQalaOrder:#Avrora.Objects.Modules.Docflow.DocflowObjects': type = 'IQalaOrder:#Avrora.Objects.Modules.Docflow.DocflowObjects'; break;
                case 'NPADocument:#Avrora.Objects.Modules.Docflow.DocflowObjects': type = 'NPADocument:#Avrora.Objects.Modules.Docflow.DocflowObjects'; break;
                case 'Meeting:#Avrora.Objects.Modules.Meetings': type = 'Meeting:#Avrora.Objects.Modules.Meetings'; break;
                case 'ReportQuery:#Avrora.Objects.Modules.Docflow.DocflowObjects': type = 'ReportQuery:#Avrora.Objects.Modules.Docflow.DocflowObjects'; break;
                case 'PlannedMeeting:#Avrora.Objects.Modules.Planned': type = 'PlannedMeeting:#Avrora.Objects.Modules.Planned'; break;
                case 'Reception:#Avrora.Objects.Modules.ReceptionSchedule': type = 'Reception:#Avrora.Objects.Modules.ReceptionSchedule'; break;

                default: type = 'Unknown'; break;
            }

            switch (type)
            {
                case 'OutgoingDocument:#Avrora.Objects.Modules.Docflow.DocflowObjects':
                
                    if (this.documentInfo.Document.NotDraft)
                        return this.$t('Исходящий_документ');

                    return this.documentInfo.Document.RegState != 1 
                        ? this.$t('Проект_исходящего_документа')
                        : this.$t('Исходящий_документ');

                case 'IncomingDocument:#Avrora.Objects.Modules.Docflow.DocflowObjects': //нет версий                            
                    return this.incommingDocumentNameByTypeC4;                

                case 'InnerDocument:#Avrora.Objects.Modules.Docflow.DocflowObjects':
                    return this.innergDocumentNameByTypeC4;                

                case 'EuolStatement:#Avrora.Objects.Modules.Docflow.DocflowObjects': //нет версий
                    return this.euolStatementNameByPerCategory;
                
                case 'IQalaStatement:#Avrora.Objects.Modules.Docflow.DocflowObjects':
                    return this.iQalaStatementDocumentName;
                    
                case 'Contract:#Avrora.Objects.Modules.Docflow.DocflowObjects.C4':
                    return this.contractDocumentName;

                case 'Resolution:#Avrora.Objects.Modules.Docflow.DocflowObjects': //нет версий //нет номера
                {
                    let docName;
                    switch(this.documentInfo.Document.__type)
                    {
                        case 'OutgoingDocument:#Avrora.Objects.Modules.Docflow.DocflowObjects': docName = this.$t('Исходящий_документ'); break;
                        case 'IncomingDocument:#Avrora.Objects.Modules.Docflow.DocflowObjects': docName =  this.incommingDocumentNameByTypeC4; break;
                        case 'InnerDocument:#Avrora.Objects.Modules.Docflow.DocflowObjects': docName = this.innergDocumentNameByTypeC4; break;
                        case 'EuolStatement:#Avrora.Objects.Modules.Docflow.DocflowObjects': docName = this.euolStatementNameByPerCategory; break;
                        case 'ProtocolDocument:#Avrora.Objects.Modules.Docflow.DocflowObjects': docName = this.protocolDocumentNameByTypeC4; break;
                        default: docName = ''; break;
                    }
                    if (this.$store.getters['getCurrentModule'] == 'orders'){
                        if (this.$store.getters['global/actionsource/isMainResolution'])
                            return `${this.$t('Поручение_на')} ${docName}`;
                        else 
                            return `${this.$t('Задание_на')} ${docName}`;
                    }
                    return `${this.$t('Резолюция_на')} ${docName}`;
                }

                case 'ActItem:#Avrora.Objects.Modules.Docflow.DocflowObjects': //нет версий //нет номера
                    return this.$t('Пункт_к_организационно-распорядительному_документу');
                
                case 'IQalaOrder:#Avrora.Objects.Modules.Docflow.DocflowObjects': //нет версий //нет номера
                    return `${this.$t('Наряд_на_заявку')}`;

                case 'Order:#Avrora.Objects.Modules.Docflow.DocflowObjects': //нет версий
                    return this.$t('Личное_поручение');

                case 'ReportResolution:#Avrora.Objects.Modules.Docflow.DocflowObjects': //нет версий
                    return this.$t('Задача_по_формированию_отчета');

                case 'NPADocument:#Avrora.Objects.Modules.Docflow.DocflowObjects':{
                    if (this.documentInfo.Document.RegState != 1 && !this.documentInfo.Document.IsAccepted)
                        return this.$t('Проект_Нормативно-правового_акта');

                    switch(this.documentInfo.Document.NPAType){
                        case 0:
                            return this.$t('Решение');
                        case 1:
                            return this.$t('Постановление');
                        case 2:
                            return this.$t('Распоряжение');
                        default:
                            return this.$t('Нормативно-правовой_акт');
                    }
                }
                    
                case 'ProtocolDocument:#Avrora.Objects.Modules.Docflow.DocflowObjects': //нет версий
                    return this.protocolDocumentNameByTypeC4;

                case 'Meeting:#Avrora.Objects.Modules.Meetings':
                    return this.documentInfo.is_new_record ? this.$t('Новое_совещание') : this.$t('Совещание')+' №' + this.documentInfo.Number;
                
                case 'ReportQuery:#Avrora.Objects.Modules.Docflow.DocflowObjects':
                    return this.documentInfo.is_new_record ? this.$t('Новый_запрос_на_формирование_отчета') : this.$t('Запрос_на_формирование_отчета');

                case 'PlannedMeeting:#Avrora.Objects.Modules.Planned':
                    return this.documentInfo.is_new_record ? this.$t('Новое_мероприятие') : this.$t('Мероприятие');

                
                case 'Reception:#Avrora.Objects.Modules.ReceptionSchedule':
                    return this.documentInfo.is_new_record ? this.$t('Новая_запись_графика_приема') : this.$t('Запись_графика_приема');

                default:
                    return this.documentInfo.DocumentName;
            }
        },        
        docNumber()
        {
            if(!this.documentInfo.Document)
                return '';

            if (['Resolution:#Avrora.Objects.Modules.Docflow.DocflowObjects', 'ActItem:#Avrora.Objects.Modules.Docflow.DocflowObjects','ReportQuery:#Avrora.Objects.Modules.Docflow.DocflowObjects'].includes(this.documentInfo.Document.__type))
                return '';

            switch (this.documentInfo.Document.RegState) 
            {
                case 1:  return `№${this.documentInfo.Document.Card.RegNumber}`;
                case 2:  return this.$t('Б/Р');
                default: return !this.documentInfo.Document.is_new_record && this.documentInfo.Document.Card.DraftNumber ? `№${this.documentInfo.Document.Card.DraftNumber}` : '';
            }
        },
        docDate()
        {
            if(!this.documentInfo.Document)
            {
                if (this.documentInfo.__type == 'Order:#Avrora.Objects.Modules.Docflow.DocflowObjects')
                    return this.documentInfo.ResolutionDate ? `${this.$t('от_время_value.message', { value: this.formatDate(this.documentInfo.ResolutionDate, 'DD.MM.YYYY') })}` : '';

                if (this.documentInfo.__type == 'Meeting:#Avrora.Objects.Modules.Meetings' && !this.documentInfo.is_new_record)
                    return this.documentInfo.RecDate ? `${this.$t('на_время_value.message', { value: this.formatDate(this.documentInfo.Date, 'DD.MM.YYYY') })}` : '';
            
                return '';
            }

            return this.documentInfo.Document.RegState != 1
                ? this.documentInfo.Document.CreateDate ? `${this.$t('от_время_value.message', { value: this.formatDate(this.documentInfo.Document.CreateDate, 'DD.MM.YYYY') })}` : ''
                : this.documentInfo.Document.Card.RegDate ? `${this.$t('от_время_value.message', { value: this.formatDate(this.documentInfo.Document.Card.RegDate, 'DD.MM.YYYY') })}` : '';
        },
        docVersion()
        {
            if (!this.documentInfo.Document)
                return '';

            if (!['ProtocolDocument:#Avrora.Objects.Modules.Docflow.DocflowObjects','OutgoingDocument:#Avrora.Objects.Modules.Docflow.DocflowObjects', 'InnerDocument:#Avrora.Objects.Modules.Docflow.DocflowObjects'].includes(this.documentInfo.Document.__type))
                return '';

            return this.documentInfo.Document.RegState != 1 || this.dsType === 'ProtocolDocument'
                ? this.documentInfo.Document.is_new_record ? '' : (this.documentInfo.Document.Version ? `, ${this.$t('Версия')} ${this.documentInfo.Document.Version}` : '')
                : '';
        },
        documentStatusText() 
        {
            if (this.documentInfo.__type == 'Meeting:#Avrora.Objects.Modules.Meetings'){
                if (this.documentInfo.is_new_record)
                    return this.$t('Новое');
                if (this.documentInfo.Status == 1)
                    return this.$t('Отменено');
                switch(this.documentInfo.WorkStatus){
                    case 1: return this.$t('Запланировано');
                    case 2: return this.$t('Проводится');
                    case 3: return this.$t('Завершено');
                    default: return '';
                }
            }

            if (this.documentInfo.__type == 'PlannedMeeting:#Avrora.Objects.Modules.Planned') {
                switch(this.documentInfo.Status) {
                    case 1: return this.$t('Завершено');
                    case 2: return this.$t('Запланировано');                    
                    default: return '';
                }                
            }

            if (this.documentInfo.__type == 'Reception:#Avrora.Objects.Modules.ReceptionSchedule') {
                // if (this.documentInfo.is_new_record)
                //     return this.$t('Новая');
                
                switch(this.documentInfo.ReceptionStatus) {
                    case 0: return this.$t('Свободно');
                    case 1: return this.$t('Зарезервировано');
                    case 2: return this.$t('Занято');                    
                    default: return '';
                }         
            }

            if(!this.documentInfo.Document)
                return '';

            if (this.documentInfo.Document.ArchYear)
                return `${this.$t('Статус_документа')}: ${this.$t('Архивный')}`;

            if (this.documentInfo.Document.RegState != 1 || ['IQalaStatement:#Avrora.Objects.Modules.Docflow.DocflowObjects', 'Contract:#Avrora.Objects.Modules.Docflow.DocflowObjects.C4'].includes(this.documentInfo.Document.__type))
            {
                let statusText;
                switch (this.documentInfo.Status)
                {
                    case 0: statusText = this.$t('Новый'); break;
                    case 1: statusText = this.$t('На_регистрации'); break;
                    case 2: statusText = this.$t('Отклонен'); break;
                    case 3: statusText = this.$t('Зарегистрирован'); break;
                    case 4: statusText = this.$t('На_рассмотрении'); break;
                    case 5: statusText = this.$t('Рассмотрен'); break;
                    case 6: statusText = this.$t('На_подписи'); break;
                    case 7: statusText = this.$t('Подписан'); break;
                    case 8: statusText = this.$t('Отправлен'); break;
                    case 9: statusText = this.$t('На_согласовании'); break;
                    case 10: statusText = this.$t('Согласован'); break;
                    case 11: statusText = this.$t('На_исполнении'); break;
                    case 12: statusText = this.$t('Исполнено'); break;
                    case 13: statusText = this.$t('Завершен'); break;
                    case 14: statusText = this.$t('Удален'); break;

                    case 15: statusText = this.$t('Контроль'); break;
                    case 17: statusText = this.$t('Особый_контроль'); break;
                    case 18: statusText = this.$t('Снят_с_контроля'); break;

                    case 19: statusText = this.$t('На_доработке'); break;
                    case 20: statusText = this.$t('Принят'); break;
                    case 21: statusText = this.$t('Ожидание_оплаты'); break;
                    case 22: statusText = this.$t('Оплата_произведена'); break;
                    case 23: statusText = this.$t('На_подписании_у_заявителя'); break;                    
                    case 24: statusText = this.$t('На_подписании_у_услугодателя'); break;
                    case 25: statusText = this.$t('Отказ'); break;
                    case 26: statusText = this.$t('Подписан_заявителем'); break;
                    case 27: statusText = this.$t('Заключен'); break;

                    case 28: statusText = this.$t('Устарел'); break;
                    case 29: statusText = this.$t('Без_вложений'); break;
                    case 30: statusText = this.$t('Ожидание_приема'); break;

                    default: statusText = ''; break;
                }

                if (statusText === '')
                {
                    return '';
                }
                else
                {
                    switch(this.documentInfo.Document.__type)
                    {
                        case 'IQalaStatement:#Avrora.Objects.Modules.Docflow.DocflowObjects': return `${this.$t('Статус_заявки')}: ${statusText}`;
                        case 'Contract:#Avrora.Objects.Modules.Docflow.DocflowObjects.C4': return `${this.$t('Статус_договора')}: ${statusText}`;

                        default: return `${this.$t('Статус_документа')}: ${statusText}`;

                    }                        
                }
            }
            else
            {
                if (this.documentInfo.Document.__type == 'NPADocument:#Avrora.Objects.Modules.Docflow.DocflowObjects') {
                    let statusText = "Действующий";

                    if (this.documentInfo.Document.ChangedByList?.length > 0)
                        statusText = "С_изменениями";

                    let date = this.$moment(this.documentInfo.Document.Srok);

                    if (this.$moment() > date)
                        statusText = "Утративший_силу";

                    return `${this.$t('Статус_документа')}: ${this.$t(statusText)}`;
                }

                if (['OutgoingDocumentDSP:#Avrora.Objects.Modules.Docflow.DocflowObjects', 'IncomingDocumentDSP:#Avrora.Objects.Modules.Docflow.DocflowObjects'].includes(this.documentInfo.Document.__type)) {
                    let statusText;
                    
                    switch (this.documentInfo.Status)
                    {
                        case 14: statusText = this.$t('Удален'); break;
                        default: break;
                    }

                    return statusText ? `${this.$t('Статус_документа')}: ${statusText}` : '';
                }

                return '';
            }
        },

    },
    methods:{
        formatDate: sys.dateFormat,
        handleFavoriteClick() {
            if (this.favoriteClickHandler && typeof this.favoriteClickHandler === 'function') {
                this.favoriteClickHandler();
            }
        },
        mapIcon (source) {
            return this.getIcons[source] ?? "fas fa-ban";
        },
        async actionButtonClick (event, button) {
            let actions = Reflect.ownKeys(this.$store._actions).filter(i => i.includes('global/actionsource/')).map(i => {return i.split('/')[2]})
            
            if (actions.includes(button.Action))
                await this.$store.dispatch(`global/actionsource/${button.Action}`, {event, button});
            else
                this.$notify.alert(`Действие_${button.Action}_не_реализовано.`);
        }
    }
}
</script>